import React from 'react';
import { Home as HomeInternal } from 'components/features/home/Home';

const Home: React.FC = () => {
  return (
    <>
      <HomeInternal />
    </>
  );
};

export default Home;
